import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const trigger = dom.find('[data-bio-trigger]');
    const triggerText = trigger.text();
    const bio = dom.find('[data-bio]');
    const bioInner = dom.find('[data-bio-inner]');
    const hero = dom.find('[data-hero]');

    let isShowing = false;

    const show = () => {
        if (!isShowing) {
            isShowing = true;

            bio.addClass('is-showing');
            trigger.text(trigger.data('close-text'));

            TweenMax.killTweensOf([bioInner.get(0), bio.get(0)]);
            TweenMax.set(bio.get(0), { visibility: 'visible', opacity: 0 });
            TweenMax.set(bioInner.get(0), { opacity: 0, y: -80 });

            TweenMax.to(bio.get(0), 0.3, { opacity: 1, ease: Quad.easeOut });
            TweenMax.to(bioInner.get(0), 0.75, { delay: 0.3, opacity: 1, y: 0, ease: Quint.easeOut });
        }
    };

    const hide = () => {
        if (isShowing) {
            isShowing = false;

            bio.removeClass('is-showing');
            trigger.text(triggerText);

            TweenMax.killTweensOf([bioInner.get(0), bio.get(0)]);
            TweenMax.to(bioInner.get(0), 0.5, { opacity: 0, y: -40, ease: Quint.easeInOut });
            TweenMax.to(bio.get(0), 1, { delay: 0.5, opacity: 0, ease: Quad.easeOut, clearProps: 'opacity, y' });
        }
    };

    const toggleBio = e => {
        e.preventDefault();

        if (isShowing) {
            hide();
            return;
        }

        show();
    };

    const init = () => {
        hero.append(bio);
        trigger.on('click', toggleBio);
    };

    const destroy = () => {
        trigger.off('click', toggleBio);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Creative.js